import { useQuery, useMutation, } from "@tanstack/react-query";
export const createTranslationsQueries = (requests, queryClient) => ({
    useListTranslations: (params, options = {}) => useQuery({
        queryKey: ["translations", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listTranslations(params);
        },
        ...options,
    }),
    useSaveTranslation: (options = {}) => useMutation({
        ...options,
        mutationFn: (payload) => {
            return requests.saveTranslation(payload);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["translations"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    usePopulateTranslations: (options = {}) => useMutation({
        ...options,
        mutationFn: (payload) => {
            return requests.populateTranslations(payload);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["translations"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useImportTranslations: (options = {}) => useMutation({
        ...options,
        mutationFn: (payload) => {
            return requests.importTranslations(payload);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["translations"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useTranslateAllTranslations: (options = {}) => useMutation({
        ...options,
        mutationFn: (payload) => {
            return requests.translateAllTranslations(payload);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["translations"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map